import { Feature } from "ol";
import { Geometry } from "ol/geom";
import { NavaidModel } from "./navaid";
import GeoJSON from 'ol/format/GeoJSON';

export class PendingCalculation{
    calculationDTO: any;

    modalDTO: any

    calculationType: PendingCalculationType

    elevationType: string;

    // use of one or the other depends on the calculation type. Should not be used simultaneously.
    selectedFeatures: Feature<Geometry>[] | null = null;
    selectedNavaids: NavaidModel[] | null = null;

    constructor(){}

    mapToPendingCalculationDTO(): PendingCalculationDTO{
        const pendingCalculationDTO: PendingCalculationDTO = new PendingCalculationDTO();
        pendingCalculationDTO.calculationDTO = JSON.stringify(this.calculationDTO);
        pendingCalculationDTO.modalDTO = JSON.stringify(this.modalDTO);
        pendingCalculationDTO.calculationType = this.calculationType.toString();
        pendingCalculationDTO.elevationType = this.elevationType;
        if (this.selectedFeatures != null){
            // serialize features
            const selectedFeaturesString: string[] =  [];
            const geoJsonFormat = new GeoJSON();
            for (const selectedFeature of this.selectedFeatures){
                selectedFeaturesString.push(geoJsonFormat.writeFeature(selectedFeature))
            }
            pendingCalculationDTO.selectedFeatures = JSON.stringify(selectedFeaturesString);
        } else {
            pendingCalculationDTO.selectedNavaids = JSON.stringify(this.selectedNavaids);
        }
        return pendingCalculationDTO;
    }

}

export class PendingCalculationDTO{
    calculationDTO: string;

    modalDTO: string;

    calculationType: string;

    elevationType: string;

    // use of one or the other depends on the calculation type. Should not be used simultaneously.
    selectedFeatures: string | null = null;
    selectedNavaids: string | null = null;

    constructor(){}

    public static mapToPendingCalculation(pendingCalculationDTO: PendingCalculationDTO): PendingCalculation{
        const pendingCalculation: PendingCalculation = new PendingCalculation();
        pendingCalculation.calculationDTO = JSON.parse(pendingCalculationDTO.calculationDTO);
        pendingCalculation.modalDTO = JSON.parse(pendingCalculationDTO.modalDTO);
        pendingCalculation.calculationType = pendingCalculationDTO.calculationType as PendingCalculationType;
        pendingCalculation.elevationType = pendingCalculationDTO.elevationType;
        if (pendingCalculationDTO.selectedFeatures != null){
            // deserialize features
            const selectedFeatures: any[] = JSON.parse(pendingCalculationDTO.selectedFeatures);
            pendingCalculation.selectedFeatures = [];
            const geoJsonFormat = new GeoJSON();
            for (const selectedFeature of selectedFeatures){
                const feature = geoJsonFormat.readFeature(selectedFeature);
                if (Array.isArray(feature)) {
                    pendingCalculation.selectedFeatures.push(...feature);
                } else {
                    pendingCalculation.selectedFeatures.push(feature);
                }
            }
        } else {
            pendingCalculation.selectedNavaids = JSON.parse(pendingCalculationDTO.selectedNavaids);
        }
        return pendingCalculation;
    }
}

export class PendingCalculationMap {
    calculationId: number;
    id: number;
    pendingCalculation: string; // JSON string
    projectId: number;
}

export const enum PendingCalculationType{
    PERFORMANCE_ANALYSIS = "PERFORMANCE_ANALYSIS",
    VERTICAL_PROFILE = "VERTICAL_PROFILE",
    COVERAGE_ASSESSMENT_TOOL = "COVERAGE_ASSESSMENT_TOOL",
    COVERAGE = "COVERAGE",
    OVERLAP = "OVERLAP",
    CUMULATIVE_COVERAGE = "CUMULATIVE_COVERAGE",
    PERFORMANCE_DME = "PERFORMANCE_DME",
    PERFORMANCE_VOR = "PERFORMANCE_VOR",
    PERFORMANCE_REPORT = "PERFORMANCE_REPORT",
    SITING_TOOL = "SITING_TOOL",
    DOC_AND_SEC = "DOC_AND_SEC",

    //#region GRIT
    IMPACT_ASSESSMENT = "IMPACT_ASSESSMENT",
    //endregion
}
